import ribbon from "../assets/top-ribbon.svg";
import "./TopRibbon.css";

/**
 * Decorative wavy ribbon that runs across the very top of the page.
 * Purely visual, so it's hidden from assistive tech.
 */
function TopRibbon() {
  return (
    <div
      className="TopRibbon"
      style={{ backgroundImage: `url(${ribbon})` }}
      aria-hidden="true"
    />
  );
}

export default TopRibbon;
